const html = require('choo/html')
const { Button, Input, Wave } = require('./elements.js')

module.exports = function Recording(state, emit) {
  const recordingHidden = state.isRecordingOpen ? 'visible' : 'hidden'
  return html`
    <ul id="recording" class="contour space-tight ${recordingHidden}">
      <li class="size-big" id="hold-to-record">
        ${Button(
          {
            onMouseDown: () => emit('startrecording'),
            onMouseUp: () => emit('stoprecording')
          },
          'HOLD TO RECORD'
        )}
      </li>
      <li class="size-biggest" id="wave-preview">
        ${Wave({
          reads: state.meterReads,
          slicePosition: state.recordingSlice,
          onClick: (e) => emit('slicewave', e)
        })}
      </li>
      <li class="size-big" id="press-to-test">
        ${Button(
          {
            onMouseDown: () => emit('startsampletest'),
            onMouseUp: () => emit('stopsampletest')
          },
          'PRESS TO TEST'
        )}
      </li>
      <li class="size-big"></li>
      <li class="size-big" id="recording-name">
        ${Input({
          placeholder: `Type your sample name here`,
          value: state.recordingName || '',
          onChange: (e) => emit('updaterecordingname', e.target.value),
          onFocus: () => emit('starttyping'),
          onBlur: () => emit('stoptyping')
        })}
      </li>
      <li class="size-big" id="recording-save">
        ${Button(
          { onClick: () => emit('savesampletest') },
          'SAVE TO LIBRARY'
        )}
      </li>
    </ul>
  `
}
